// Angular
import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";

// Models
import { Attachment } from "./../../models/attachment";
import { Club, Course, Tee } from "./../../models/club";
import { Tournament } from "./../../models/tournament";
// External
import { AngularFireAuth } from "angularfire2/auth";
import { AngularFireDatabase } from "angularfire2/database";
import { FirebaseApp } from "angularfire2";
import * as moment from "moment";
import * as lodash from "lodash";
import { ApiService } from "./../../services/api";
import { ElasticService } from "./../../services/elastic";
import { OAuthService } from "app/services/o-auth";

@Component({
  templateUrl: "./update.tournament.component.html",
})
export class UpdateTournamentComponent {
  public clubs: Array<Club>;
  public query: string;
  private typingDelay: any;
  public loading: boolean;
  public form: FormGroup;
  public minEndDate: Date;

  public club: any;
  public startTime: Array<any>;

  public selectedCourse: Course;
  public course: Course;
  public tournamentId: string;
  public courses: Array<Course>;
  public tees: Array<Tee>;
  public holesPart: Array<{ value: number; name: string }>;
  public teamPlay: Array<{ value: number; name: string }>;
  public modes: Array<any>;
  private attachment: Attachment;
  private attachmentExt: string;
  public tournament: any;
  public user: any;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private firebase: FirebaseApp,
    private fireAuth: AngularFireAuth,
    private apiService: ApiService,
    private oAuthService: OAuthService,
    private fireDatabase: AngularFireDatabase,
    private elasticSearch: ElasticService
  ) {
    this.tournamentId = this.route.snapshot.paramMap.get("id");
    this.club = new Club();
    this.user = this.oAuthService.getClub();

    this.tournament = {
      eventName: "",
      startDate: "",
      // entriesEndDate: "",
      endDate: "",
      info: "",
      image: "",
      uid: this.fireAuth.auth.currentUser.uid,
      cid: "",
      course: "",
      tee: "",
      type: "",
      holesPart: "",
      holesCount: "",
      teamPlay: "",
      proAm: "",
      isClosed: "",
      team: "false",
    };
    this.teamPlay = [
      { value: 1, name: "Single" },
      { value: 2, name: "Best of 2" },
      { value: 3, name: "Best of 3" },
      { value: 4, name: "Best of 4" },
    ];
    this.tees = [];
    this.courses = [];
    this.holesPart = [];

    this.fireDatabase
      .object(`/tournaments/${this.tournamentId}`)
      .subscribe((tournamnet) => {
        this.tournament = tournamnet;
        console.log(this.tournament);

        if (this.tournament) {
          this.playerPerTeamChangeInitial(this.tournament.teamPlay);

          this.tournament.member = this.tournament.isClosed;
          this.tournament.follower = !this.tournament.isClosed;

          this.tournament.t = this.tournament.team;
          this.tournament.i = !this.tournament.team;

          this.tournament.startDate = this.tournament.startDate * 1000;
          // this.tournament.entriesEndDate = this.tournament.entriesEndDate * 1000;
          this.tournament.endDate = this.tournament.endDate * 1000;

          const startDate = new Date(this.tournament.startDate);
          this.tournament.startDate = startDate;
          // const eedate = new Date(this.tournament.entriesEndDate);
          // this.tournament.entriesEndDate = eedate


          // this.tournament.startTime = `${startDate.getHours()}:${startDate.getMinutes()}`
          const endDate = new Date(this.tournament.endDate);
          this.tournament.endDate = `${endDate.getHours()}:${endDate.getMinutes()}`;
          console.log(this.tournament.startTime, this.tournament.endDate);
        }

        this.fireDatabase
          .object(`/users/${this.tournament.cid}`)
          .subscribe((club) => {
            this.club = club;
            // console.log(this.club);
            this.query = this.club.name;
            //      this.changeClub(this.club);
            this.courses = [];
            lodash.forEach(club.courses, (course, key) => {
              course.$key = key;
              if (key == this.tournament.course) {
                this.selectedCourse = course;
                // console.log(this.selectedCourse)
              }
              this.courses.push(course);
            });
            if (this.selectedCourse != undefined) {
              this.holesPart = [{ value: 1, name: "All 9" }];

              if (this.selectedCourse.holes === 18) {
                this.holesPart = [
                  { value: 0, name: "All 18" },
                  { value: 1, name: "Front 9" },
                  { value: 2, name: "Back 9" },
                ];
              }
            }

            // console.log(this.holesPart);
            lodash.forEach(this.selectedCourse.tees, (tee, key) => {
              tee.$key = key;
              // if(key==this.tournament.course){
              //   //  this.selectedCourse=course;
              console.log(tee);

              // }
              this.tees.push(tee);
            });
            console.log(this.tees);
          });
      });
    this.modes = [];

    this.modes.push(
      { value: 1, name: "Best of 1" },
      { value: 2, name: "Best of 2" },
      { value: 3, name: "Best of 3" },
      { value: 4, name: "Best of 4" }
    );

    this.minEndDate = new Date();
    // this.startTime = this.timelineLabels('07:00', 30, 'm')
    // this.startTime = lodash.unionBy(this.startTime)
    if (this.user.type == 1) this.chooseClub(this.user);
  }
  timelineLabels(desiredStartTime, interval, period) {
    const periodsInADay = moment.duration(1, "day").as(period);

    const timeLabels = [];
    const startTimeMoment = moment(desiredStartTime, "hh:mm");
    for (let i = 0; i <= periodsInADay; i += interval) {
      startTimeMoment.add(i === 0 ? 0 : interval, period);
      console.log();
      if (startTimeMoment.hour() >= 7)
        timeLabels.push(startTimeMoment.format("hh:mm A"));
    }

    return timeLabels;
  }
  changeCourse() {
    this.tees = [];
    lodash.forEach(this.courses, (course, key) => {
      if (course.$key == this.tournament.course) {
        this.selectedCourse = course;
      }
    });
    this.holesPart = [{ value: 1, name: "All 9" }];

    if (this.selectedCourse.holes === 18) {
      this.holesPart = [
        { value: 0, name: "All 18" },
        { value: 1, name: "First 9" },
        { value: 2, name: "Last 9" },
      ];
    }
    this.tournament.holesPart = this.holesPart[0].value;

    lodash.forEach(this.selectedCourse.tees, (tee, key) => {
      tee.$key = key;

      this.tees.push(tee);
    });
    if (this.tees.length > 0) {
      this.tournament.tee = this.tees[0].$key;
    }
    console.log(this.tournament.course);

    console.log(this.tees);
  }
  remove() {
    this.tournament.image = "";
  }
  changeAttachment(attachment: Attachment): void {
    this.attachment = attachment;

    if (this.attachment) {
      this.attachmentExt = this.attachment.file.name.split(".").pop();
    } else {
      this.attachmentExt = "";
    }
  }

  changeStartDate(date: number) {
    console.log(date);

    this.form.controls["startDate"].patchValue(date);
    this.minEndDate = moment.unix(date).toDate();
  }



  changeEndDate(date: number) {
    this.form.controls["endDate"].patchValue(date);
  }
   playerPerTeamChangeInitial(event) {
    this.modes = [];

    if (event === 4) {

      this.modes.push(
        { value: 1, name: "Best 1 score", selectable: false },
        { value: 2, name: "Best 2 scores", selectable: false },
        { value: 3, name: "Best 3 scores", selectable: false },
        { value: 4, name: "Best 4 scores", selectable: false },
        { value: 5, name: "Alternate Pairs ", selectable: true },
        { value: 6, name: "Scramble ", selectable: true }
      );
    }
    if (event === 3) {

      this.modes.push(
        { value: 1, name: "Best 1 score", selectable: false },
        { value: 2, name: "Best 2 scores", selectable: false },
        { value: 3, name: "Best 3 scores", selectable: false },
        { value: 5, name: "Alternate Pairs ", selectable: true },
        { value: 6, name: "Scramble ", selectable: true }
      );
    }

    if (event === 2) {

      this.modes.push(
        { value: 1, name: "Best 1 score", selectable: false },
        { value: 2, name: "Best 2 scores", selectable: false },
        { value: 5, name: "Alternate Pairs ", selectable: true },
        { value: 6, name: "Scramble ", selectable: true }
      );
    }
  }

  playerPerTeamChange(event) {
    this.modes = [];

    if (event === 4) {
      this.tournament.scoreTeamPlay = 4;

      this.modes.push(
        { value: 1, name: "Best 1 score", selectable: false },
        { value: 2, name: "Best 2 scores", selectable: false },
        { value: 3, name: "Best 3 scores", selectable: false },
        { value: 4, name: "Best 4 scores", selectable: false },
        { value: 5, name: "Alternate Pairs ", selectable: true },
        { value: 6, name: "Scramble ", selectable: true }
      );
    }
    if (event === 3) {
      this.tournament.scoreTeamPlay = 3;

      this.modes.push(
        { value: 1, name: "Best 1 score", selectable: false },
        { value: 2, name: "Best 2 scores", selectable: false },
        { value: 3, name: "Best 3 scores", selectable: false },
        { value: 5, name: "Alternate Pairs ", selectable: true },
        { value: 6, name: "Scramble ", selectable: true }
      );
    }

    if (event === 2) {
      this.tournament.scoreTeamPlay = 2;

      this.modes.push(
        { value: 1, name: "Best 1 score", selectable: false },
        { value: 2, name: "Best 2 scores", selectable: false },
        { value: 5, name: "Alternate Pairs ", selectable: true },
        { value: 6, name: "Scramble ", selectable: true }
      );
    }
  }
  changeQuery() {
    clearTimeout(this.typingDelay);
    // console.log("change")
    //  this.onChange.emit();

    this.typingDelay = setTimeout(() => {
      this.searchMention();
    }, 400);
  }

  onFocus() {
    this.searchMention();
  }

  chooseClub(club: Club) {
    this.tees = [];
    this.tournament.tee = "";
    this.courses = [];
    this.holesPart = [];
    this.tournament.course = "";
    this.tournament.tee = "";
    this.tournament.holesPart = "";
    this.tournament.clubName = club.name;

    if (!club) {
      return;
    }

    this.club = club;
    this.tournament.cid = club.$key ? club.$key : this.club.cid;
    // console.log(club)
    //      this.form.controls['cid'].patchValue(this.club.$key);
    this.courses = [];
    lodash.forEach(club.courses, (course, key) => {
      this.courses.push(lodash.assign(course, { $key: key }));
    });

    if (this.courses.length > 0) {
      this.tournament.course = this.courses[0].$key;
      this.changeCourse();
    }
    this.clubs = [];
  }

  private uploadFile(): Promise<any> {
    return new Promise((resolve, reject) => {
      if (this.attachment) {
        const filename = `${moment().unix()}.${this.attachmentExt}`;
        this.firebase
          .storage()
          .ref(`/tournamets/${this.fireAuth.auth.currentUser.uid}`)
          .child(filename)
          .put(this.attachment.file)
          .then((result) => resolve(result))
          .catch((error) => reject(error));
      } else {
        return resolve(true);
      }
    });
  }
  searchMention() {
    const queryParams = {
      index: "users",
      type: "club",
      size: 10,
      "body/query/bool/must/query_string/query": `${this.club.name}*`,
      "body/query/bool/must/query_string/fields": [
        "name^10",
        "city^2",
        "state",
        "country",
      ],
    };

    this.elasticSearch
      .search(queryParams)
      .then((result) => {
        this.clubs = [];
        // console.log(result)
        lodash.forEach(result["hits"], (item) => {
          // console.log(item);
          const club = lodash.assign({ $key: item["_id"] }, item["_source"]);
          this.clubs.push(club);
          // console.log(this.clubs)
        });
      })
      .catch((error) => {
        console.error(error);
      });
  }

  public submit(): void {
    console.log(this.tournament);
    this.tournament.teamPlay = this.tournament.playerPerTeam;

    if (this.tournament.type == 2 && !this.tournament.organizerType)
    { 
      alert('Please select Organizer Type')
      return
    }


    // const eedate = new Date(this.tournament.entriesEndDate);
    // const eedate1 = moment(this.tournament.entriesEndDate).format("YYYY-MM-DD");
    // this.tournament.entriesEndDate = moment(eedate1).unix();


    const startDate = new Date(this.tournament.startDate);
    console.log(startDate);
    const sdate = moment(this.tournament.startDate).format("YYYY-MM-DD");
    const sdateTime = moment(
      `${sdate} ${this.tournament.startTime}`,
      "YYYY-MM-DD HH:mm A"
    ).unix();

    this.tournament.startDate = sdateTime;
    const edate = moment(startDate).format("YYYY-MM-DD");
    const edateTime = moment(
      `${edate} ${this.tournament.endDate}`,
      "YYYY-MM-DD HH:mm"
    );
    console.log(edateTime.unix());
    this.tournament.endDate = edateTime.unix();
    this.loading = true;
    console.log(this.tournament.startDate);

    this.uploadFile()
      .then((fileResult) => {
        if (fileResult && fileResult.downloadURL) {
          this.tournament.image = fileResult.downloadURL;
        }
        if (this.tournament.member)
          this.tournament.isClosed = this.tournament.member;
        delete this.tournament.member;
        delete this.tournament.follower;
        // this.tournament.team = this.tournament.t;
        if (!this.tournament.team) {
          this.tournament.teamPlay = 0;
        }
        delete this.tournament.t;
        delete this.tournament.i;
        let key = this.club.$key ? this.club.$key : this.club.cid;
        if (this.tournament.slopeRating) {
          this.tournament.slopeRating = +this.tournament.slopeRating;
        } else {
          this.tournament.slopeRating = 113;
        }
        this.apiService
          .object(
            "/courses/" +
              key +
              "/" +
              this.tournament.course +
              "/" +
              this.tournament.tee
          )
          .then((response) => {
            let updates = {};

            updates["/tournaments/" + this.tournamentId] = this.tournament;
            updates["/tournaments-course/" + this.tournamentId] = response;

            console.log(updates);
            return this.apiService.bulkUpdate(updates);
          })
          .then((res) => {
            setTimeout(() => {
              return this.router.navigate(["/components/tournaments"]);
            }, 2000);
          })
          .catch((error) => {
            console.error(error);

            alert("Sorry, something went wrong!");
            this.loading = false;
          });
      })
      .catch((error) => {
        this.error(error);
      });
  }

  private error(error): void {
    console.error(error);
    alert("Sorry, something went wrong!");

    this.loading = false;
  }

  memberChange(event) {
    this.tournament.member = event;
    this.tournament.follower = !event;
  }

  followerChange(event) {
    this.tournament.member = !event;
    this.tournament.follower = event;
  }
  tChange(event) {
    this.tournament.t = event;
    this.tournament.i = !event;
    this.tournament.team = this.tournament.t;
  }
  iChange(event) {
    this.tournament.t = !event;
    this.tournament.i = event;
    this.tournament.team = this.tournament.t;
  }

  onUnlimitedPlayersClick(event) {
    let element = document.getElementById("numberOfEntries");
    if (this.tournament.isUnlimitedPlayers == true) {
      element.setAttribute("disabled", "disabled");
    } else {
      element.removeAttribute("disabled");
    }
  }

  handleTypeChange(event) {
    let element = document.getElementById("numberOfEntries");
    if (this.tournament.type != 2) {
      element.removeAttribute("disabled");
    } else {
      this.onUnlimitedPlayersClick(null);
    }
  }
}
